/**
 * Mobile-only: after the SH banner scrolls fully past the viewport, show the fixed survey bar;
 * bar opens the bottom-sheet dialog (native <dialog>). Sheet can be dismissed by dragging the handle down.
 */
(function () {
  function sheetCloseThreshold() {
    return Math.max(88, Math.min(window.innerHeight * 0.18, 200));
  }

  function initRoot(root) {
    var section = root.closest('.shopify-section');
    /* v1: .smart-home-banner — v2: .smart-home-banner-2 (same section, sibling of fixed bar root) */
    var banner = section ? section.querySelector('[data-fixed-bar-listen-target], .smart-home-banner, .smart-home-banner-2__top') : null;
    var bar = root.querySelector('.smart-home-banner__mobile-fixed-bar');
    var dialog = root.querySelector('.smart-home-banner__mobile-fixed-bar-dialog');
    var surface = root.querySelector('.smart-home-banner__mobile-fixed-bar-dialog-surface');
    var handle = root.querySelector('.smart-home-banner__mobile-fixed-bar-dialog-handle');
    if (!banner || !bar || !dialog || !surface || !handle) return;

    var mqMobile = window.matchMedia('(max-width: 767px)');

    var dragPointerId = null;
    var dragStartY = 0;
    var dragDy = 0;
    var closingSheet = false;

    function resetSheetTransform() {
      surface.classList.remove(
        'is-sheet-dragging',
        'is-sheet-enter-from-bottom',
        'is-sheet-enter-active',
        'is-sheet-enter-animating',
        'is-sheet-exit-animating'
      );
      surface.style.transform = '';
      surface.style.transition = '';
      surface.style.animation = '';
      handle.classList.remove('is-sheet-handle-disabled');
      dialog.classList.remove('is-sheet-closing-ui');
      if (surface._sheetEnterEndTimer) {
        window.clearTimeout(surface._sheetEnterEndTimer);
        surface._sheetEnterEndTimer = null;
      }
      if (surface._sheetEnterAnimationEnd) {
        surface.removeEventListener('animationend', surface._sheetEnterAnimationEnd);
        surface._sheetEnterAnimationEnd = null;
      }
      if (surface._sheetExitAnimationEnd) {
        surface.removeEventListener('animationend', surface._sheetExitAnimationEnd);
        surface._sheetExitAnimationEnd = null;
      }
      if (surface._sheetExitEndTimer) {
        window.clearTimeout(surface._sheetExitEndTimer);
        surface._sheetExitEndTimer = null;
      }
      dragPointerId = null;
      dragDy = 0;
    }

    function isPastBanner() {
      return banner.getBoundingClientRect().bottom <= 0;
    }

    function setBarPastHero(on) {
      bar.classList.toggle('is-past-hero', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bar.setAttribute('tabindex', on ? '0' : '-1');
    }

    function updateScrollState() {
      if (!mqMobile.matches) {
        setBarPastHero(false);
        if (dialog.open) dialog.close();
        return;
      }
      setBarPastHero(isPastBanner());
    }

    var autofocusGuardUntil = 0;
    var autofocusGuardHandler = null;

    function isFormField(el) {
      return el && el.matches && el.matches('input, textarea, select, button');
    }

    function preventDialogAutofocus() {
      var active = document.activeElement;
      if (active && dialog.contains(active) && isFormField(active)) {
        active.blur();
      }
      try {
        dialog.focus({ preventScroll: true });
      } catch (err) {
        handle.focus({ preventScroll: true });
      }
    }

    function startAutofocusGuard() {
      autofocusGuardUntil = Date.now() + 1200;
      if (autofocusGuardHandler) return;
      autofocusGuardHandler = function (e) {
        if (Date.now() > autofocusGuardUntil || !dialog.open) return;
        if (!isFormField(e.target) || !dialog.contains(e.target)) return;
        if (e.target.closest('[data-sh-sheet-user-focus]')) return;
        e.target.blur();
        preventDialogAutofocus();
      };
      dialog.addEventListener('focusin', autofocusGuardHandler, true);
    }

    function stopAutofocusGuard() {
      autofocusGuardUntil = 0;
      if (autofocusGuardHandler) {
        dialog.removeEventListener('focusin', autofocusGuardHandler, true);
        autofocusGuardHandler = null;
      }
      dialog.querySelectorAll('[data-sh-sheet-user-focus]').forEach(function (el) {
        el.removeAttribute('data-sh-sheet-user-focus');
      });
    }

    dialog.addEventListener(
      'pointerdown',
      function (e) {
        if (isFormField(e.target) && dialog.contains(e.target)) {
          e.target.setAttribute('data-sh-sheet-user-focus', '');
        }
      },
      true
    );

    function openDialog() {
      if (!mqMobile.matches || dialog.open) return;
      resetSheetTransform();
      var y = window.scrollY;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion) {
        dialog.showModal();
        startAutofocusGuard();
        preventDialogAutofocus();
        requestAnimationFrame(function () {
          window.scrollTo(0, y);
          preventDialogAutofocus();
        });
        bar.setAttribute('aria-expanded', 'true');
        return;
      }

      handle.classList.add('is-sheet-handle-disabled');
      dialog.showModal();
      startAutofocusGuard();
      preventDialogAutofocus();
      requestAnimationFrame(function () {
        window.scrollTo(0, y);
        preventDialogAutofocus();
        void surface.offsetHeight;
        surface.classList.add('is-sheet-enter-animating');
      });

      function onEnterAnimationEnd(e) {
        if (e.target !== surface) return;
        var name = e.animationName || '';
        if (name.indexOf('smart-home-banner-sheet-enter') === -1) return;
        surface.removeEventListener('animationend', surface._sheetEnterAnimationEnd);
        surface._sheetEnterAnimationEnd = null;
        surface.classList.remove('is-sheet-enter-animating');
        handle.classList.remove('is-sheet-handle-disabled');
        if (surface._sheetEnterEndTimer) {
          window.clearTimeout(surface._sheetEnterEndTimer);
          surface._sheetEnterEndTimer = null;
        }
      }

      surface._sheetEnterAnimationEnd = onEnterAnimationEnd;
      surface.addEventListener('animationend', onEnterAnimationEnd);
      surface._sheetEnterEndTimer = window.setTimeout(function () {
        surface._sheetEnterEndTimer = null;
        if (surface._sheetEnterAnimationEnd) {
          surface.removeEventListener('animationend', surface._sheetEnterAnimationEnd);
          surface._sheetEnterAnimationEnd = null;
        }
        surface.classList.remove('is-sheet-enter-animating');
        handle.classList.remove('is-sheet-handle-disabled');
      }, 600);

      bar.setAttribute('aria-expanded', 'true');
    }

    function onDialogClose() {
      closingSheet = false;
      stopAutofocusGuard();
      bar.setAttribute('aria-expanded', 'false');
      resetSheetTransform();
    }

    function closeSheetAnimated() {
      if (!dialog.open) return;
      if (!mqMobile.matches) {
        dialog.close();
        return;
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        dialog.close();
        return;
      }
      if (closingSheet) return;
      closingSheet = true;
      dialog.classList.add('is-sheet-closing-ui');
      handle.classList.add('is-sheet-handle-disabled');

      surface.classList.remove('is-sheet-enter-animating');
      if (surface._sheetEnterAnimationEnd) {
        surface.removeEventListener('animationend', surface._sheetEnterAnimationEnd);
        surface._sheetEnterAnimationEnd = null;
      }
      if (surface._sheetEnterEndTimer) {
        window.clearTimeout(surface._sheetEnterEndTimer);
        surface._sheetEnterEndTimer = null;
      }

      surface.classList.remove('is-sheet-dragging');
      surface.style.transition = '';
      surface.style.transform = '';
      surface.style.animation = 'none';
      void surface.offsetHeight;
      surface.style.animation = '';

      function finishClose() {
        if (!dialog.open) return;
        if (surface._sheetExitAnimationEnd) {
          surface.removeEventListener('animationend', surface._sheetExitAnimationEnd);
          surface._sheetExitAnimationEnd = null;
        }
        if (surface._sheetExitEndTimer) {
          window.clearTimeout(surface._sheetExitEndTimer);
          surface._sheetExitEndTimer = null;
        }
        dialog.close();
      }

      function onExitAnimationEnd(e) {
        if (e.target !== surface) return;
        var name = e.animationName || '';
        if (name.indexOf('smart-home-banner-sheet-exit') === -1) return;
        finishClose();
      }

      surface._sheetExitAnimationEnd = onExitAnimationEnd;
      surface.addEventListener('animationend', onExitAnimationEnd);
      void surface.offsetHeight;
      surface.classList.add('is-sheet-exit-animating');

      surface._sheetExitEndTimer = window.setTimeout(finishClose, 450);
    }

    bar.addEventListener('click', function (e) {
      if (!mqMobile.matches) return;
      e.preventDefault();
      openDialog();
    });

    bar.addEventListener('keydown', function (e) {
      if (!mqMobile.matches) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openDialog();
      }
    });

    handle.addEventListener('pointerdown', function (e) {
      if (!mqMobile.matches || !dialog.open) return;
      if (handle.classList.contains('is-sheet-handle-disabled')) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (dragPointerId !== null) return;
      dragPointerId = e.pointerId;
      dragStartY = e.clientY;
      dragDy = 0;
      surface.classList.add('is-sheet-dragging');
      surface.style.transition = 'none';
      try {
        handle.setPointerCapture(e.pointerId);
      } catch (err) {
        /* ignore */
      }
    });

    function onHandlePointerMove(e) {
      if (e.pointerId !== dragPointerId) return;
      var dy = e.clientY - dragStartY;
      if (dy < 0) dy = 0;
      dragDy = dy;
      surface.style.transform = 'translateY(' + dy + 'px)';
    }

    function onHandlePointerEnd(e) {
      if (e.pointerId !== dragPointerId) return;
      try {
        handle.releasePointerCapture(e.pointerId);
      } catch (err2) {
        /* ignore */
      }
      surface.classList.remove('is-sheet-dragging');
      var threshold = sheetCloseThreshold();
      var dy = dragDy;

      if (dy >= threshold) {
        dragPointerId = null;
        dialog.close();
        return;
      }

      if (dy < 4) {
        resetSheetTransform();
        return;
      }

      dragPointerId = null;
      surface.style.transition = '';
      surface.style.transform = 'translateY(0)';
      var settled = false;
      var finish = function () {
        if (settled) return;
        settled = true;
        surface.removeEventListener('transitionend', finish);
        resetSheetTransform();
      };
      surface.addEventListener('transitionend', finish);
      window.setTimeout(finish, 400);
    }

    handle.addEventListener('pointermove', onHandlePointerMove);
    handle.addEventListener('pointerup', onHandlePointerEnd);
    handle.addEventListener('pointercancel', onHandlePointerEnd);

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeSheetAnimated();
    });

    dialog.addEventListener('cancel', function (e) {
      if (!mqMobile.matches || !dialog.open) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      e.preventDefault();
      closeSheetAnimated();
    });

    dialog.addEventListener('close', onDialogClose);

    window.addEventListener('scroll', updateScrollState, { passive: true });
    window.addEventListener('resize', updateScrollState);
    mqMobile.addEventListener('change', updateScrollState);
    updateScrollState();
  }

  function boot() {
    document.querySelectorAll('[data-smart-home-banner-fixed]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
